export const FILE_TYPE_MAPPING: Record<string, string> = {
  quicktime: "mov",
  "x-matroska": "mkv",
  jpeg: "jpg",
};
